class poData {
  id: number = null;
  name = "";
  date = "";
  typeReport = "";
}

export class ProcessingInstruction {
  public id: number;
  public po: poData;
  public cvCode: string;
  public buyer: poData; //'Nombre del purchasing rep'
  public createDate: string;

  public freightCarrier: string;
  public smallParcelCarrier: string;
  public trackingNumber: string;

  public pullHardDrives: string;
  public manifest: string;
  public passDataErasure1: string;
  public passDataErasure3: string;
  public hdShredding: string;
  public hdShreddingWithReport: string;
  public holdBadHardDrives: string;
  public sendStraightToTesting: string;
  public cod: string;

  public specialNotes: string;

  public netTerms: string;
  public poPriorityLevel: string;
  public warranty: string;
  public originalTotalCostPo: number;
  public companyName: string;
  public contactName: string;
  public phoneNumber: string;
  public email: string;
  public address: string;
  public city: string;
  public state: string;
  public zip: string;
  public manifestRequired: string;
  public dataDestructionRequired: string;
  public manifest_priority_level: string;

  public holdDefectiveEquipment: string;
  public sortAndSettle: string;
  public inventoryManifest: string;
  public expectedDate: any;

  public all_cod = "";
  public damages: string;
  public totalNetWeight: number;
  public shipmentQuantity: number;
  public net_terms: string;
  public description_techs: any;

  public manifestStatus: string;

  public no_manifest_priority_level: any;
  public isPaid: any;
  public clientName: any;

  public pictureRequired: number;
  public saveAsTemplate: boolean;
  public templateName: string;
  public proNumber: number;
  public equipmentComingToWarehouse: string;
  public esgReportingRequired: string;
  public sortEquipment: string;
  public securitySealPictureRequired: string;
  public notesForReceiving: string;
  public notesForManifest: string;
  public testingReportRequired: string;
  public notesForWiping: string;
  public notesForSales: string;
  public status: string;
  public dateFirstReceived: string;
  public batchCompleted: string;
  public batchTotal: string;
  public hasTheEquipmentBeenSold: string;
  public typeReport: string;
  public reference: string;
  public manifestCompletedDate: string;
  public testingCompletedDate: string;

  constructor(identyty: number) {
    this.id = null;
    this.po = new poData();
    this.cvCode = "";
    this.buyer = new poData();
    this.buyer.id = identyty;
    this.createDate = "";
    this.freightCarrier = "";
    this.smallParcelCarrier = "";
    this.trackingNumber = "";
    this.pullHardDrives = "";
    this.manifest = "";
    this.passDataErasure1 = "";
    this.passDataErasure3 = "";
    this.hdShredding = "";
    this.hdShreddingWithReport = "";
    this.holdBadHardDrives = "";
    this.sendStraightToTesting = "";
    this.all_cod = "";
    this.specialNotes = "";
    this.netTerms = "";
    this.poPriorityLevel = "";
    this.warranty = "";
    this.originalTotalCostPo = null;
    this.companyName = "";
    this.contactName = "";
    this.phoneNumber = "";
    this.email = "";
    this.address = "";
    this.city = "";
    this.state = "";
    this.zip = "";
    this.manifestRequired = "";
    this.dataDestructionRequired = "";
    this.holdDefectiveEquipment = "";
    this.sortAndSettle = "";
    this.inventoryManifest = "";
    this.manifest_priority_level = "";
    this.expectedDate = "";
    this.damages = "";
    this.totalNetWeight = 0;
    this.shipmentQuantity = 0;
    this.net_terms = "";
    this.description_techs = "";
    this.manifestStatus = "";
    this.no_manifest_priority_level = "";
    this.isPaid = "";
    this.clientName = "";
    this.pictureRequired = 0;
    this.saveAsTemplate = false;
    this.templateName = "";
    this.proNumber = 0;
    this.equipmentComingToWarehouse = 'Yes',
    this.esgReportingRequired = '';
    this.sortEquipment = '';
    this.securitySealPictureRequired = '';
    this.notesForReceiving = '';
    this.notesForManifest = '';
    this.testingReportRequired = '';
    this.notesForWiping = '';
    this.notesForSales = '';
    this.status = '';
    this.dateFirstReceived = '';
    this.batchCompleted = '';
    this.batchTotal = '';
    this.hasTheEquipmentBeenSold= '';
    this.typeReport = '';
    this.reference = '';
    this.manifestCompletedDate = '';
    this.testingCompletedDate= '';
  }

  setValues(
    id: number, // 1
    po_id: number, // 2
    po_name: string, // 3
    cvCode: string, // 4
    rep_id: number, // 5
    rep_nombre: string, // 6
    createDate: string, // 7
    freightCarrier: string, // 8
    smallParcelCarrier: string, // 9
    trackingNumber: string, // 10
    pullHardDrives: string, // 11
    manifest: string, // 12
    passDataErasure1: string, // 13
    passDataErasure3: string, // 14
    hdShredding: string, // 15
    hdShreddingWithReport: string, // 16
    holdBadHardDrives: string, // 17
    sendStraightToTesting: string, // 18
    all_cod: string, // 19
    specialNotes: string, // 20
    netTerms: string, // 21
    poPriorityLevel: string, // 22
    warranty: string, // 23
    originalTotalCostPo: number, // 24
    companyName: string, // 25
    contactName: string, // 26
    phoneNumber: string, // 27
    email: string, // 28
    address: string, // 29
    city: string, // 30
    state: string, // 31
    zip: string, // 32
    manifestRequired: string, // 33
    dataDestructionRequired: string, // 34
    holdDefectiveEquipment: string, // 35
    sortAndSettle: string, // 36
    inventoryManifest: string, // 37
    manifest_priority_level: string, // 38
    expectedDate: string, // 39
    damages: string, // 40
    totalNetWeight: number, // 41
    shipmentQuantity: number, // 42
    net_terms: string, // 43
    description_techs: string, // 44
    manifestStatus: string, // 45
    no_manifest_priority_level: string,
    isPaid: any,
    clientName: any,
    pictureRequired: number,
    saveAsTemplate: boolean,
    templateName: string,
    proNumber: number,
    equipmentComingToWarehouse: string,
    esgReportingRequired: string,
    sortEquipment: string,
    securitySealPictureRequired: string,
    notesForReceiving: string,
    notesForManifest: string,
    testingReportRequired: string,
    notesForWiping: string,
    notesForSales: string,
    status: string,
    dateFirstReceived: string,
    batchCompleted : string,
    batchTotal : string,
    hasTheEquipmentBeenSold: string,
    typeReport: string,
    reference: string,
    manifestCompletedDate :string,
    testingCompletedDate:string,
  ) {
    this.pictureRequired = pictureRequired || 0;
    this.id = id;
    this.po.id = po_id;
    this.po.name = po_name;
    this.cvCode = cvCode;
    this.buyer.id = rep_id;
    this.buyer.name = rep_nombre;
    this.createDate = createDate;
    this.freightCarrier = freightCarrier;
    this.smallParcelCarrier = smallParcelCarrier;
    this.trackingNumber = trackingNumber;
    this.pullHardDrives = pullHardDrives;
    this.manifest = manifest;
    if (passDataErasure1 === "Yes") {
      this.passDataErasure1 = "1X Pass";
    } else if (passDataErasure1 === "No") {
      this.passDataErasure1 = "3X Pass";
    } else {
      this.passDataErasure1 = passDataErasure1;
    }
    this.passDataErasure3 = passDataErasure3;
    this.hdShredding = hdShredding;
    this.hdShreddingWithReport = hdShreddingWithReport;
    this.holdBadHardDrives = holdBadHardDrives;
    this.sendStraightToTesting = sendStraightToTesting;
    this.all_cod = all_cod;
    this.specialNotes = specialNotes;
    this.netTerms = netTerms;
    this.poPriorityLevel = poPriorityLevel;
    this.warranty = warranty;
    this.originalTotalCostPo = originalTotalCostPo;
    this.companyName = companyName;
    this.contactName = contactName;
    this.phoneNumber = phoneNumber;
    this.email = email;
    this.address = address;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.manifestRequired = manifestRequired;
    this.dataDestructionRequired = dataDestructionRequired;
    this.holdDefectiveEquipment = holdDefectiveEquipment;
    this.sortAndSettle = sortAndSettle;
    this.inventoryManifest = inventoryManifest;
    this.manifest_priority_level = manifest_priority_level;
    this.expectedDate = expectedDate;
    this.damages = damages;
    this.totalNetWeight = totalNetWeight;
    this.shipmentQuantity = shipmentQuantity;
    this.net_terms = net_terms;
    this.description_techs = description_techs;
    this.manifestStatus = manifestStatus;
    this.no_manifest_priority_level = no_manifest_priority_level;
    this.isPaid = isPaid;
    this.clientName = clientName;
    this.saveAsTemplate = saveAsTemplate;
    this.templateName = templateName;
    this.proNumber = proNumber;
    this.equipmentComingToWarehouse = equipmentComingToWarehouse;
    this.esgReportingRequired = esgReportingRequired;
    this.sortEquipment = sortEquipment;
    this.securitySealPictureRequired = securitySealPictureRequired;
    this.notesForReceiving = notesForReceiving;
    this.notesForManifest = notesForManifest;
    this.testingReportRequired = testingReportRequired;
    this.notesForWiping = notesForWiping;
    this.notesForSales = notesForSales;
    this.status = status;
    this.dateFirstReceived = dateFirstReceived;
    this.batchCompleted = batchCompleted,
    this.batchTotal = batchTotal
    this.hasTheEquipmentBeenSold = hasTheEquipmentBeenSold;
    this.po.typeReport = typeReport;
    this.reference = reference;
    this.manifestCompletedDate = manifestCompletedDate;
    this.testingCompletedDate= testingCompletedDate;
  }

  saveJson() {
    let data;

    data = {
      freightCarrier: this.freightCarrier,
      smallParcelCarrier: this.smallParcelCarrier,
      trackingNumber: this.trackingNumber,
      po_id: this.po.id,
      rep_id: this.buyer.id,
      pullHardDrives: this.pullHardDrives,
      manifestRequired: this.manifest,
      passDataErasure1: this.passDataErasure1,
      passDataErasure3: this.passDataErasure3,
      hdShredding: this.hdShredding,
      hdShreddingWithReport: this.hdShreddingWithReport,
      sendStraightToTesting: this.sendStraightToTesting,
      holdBadHardDrives: this.holdBadHardDrives,
      cod: this.cod,
      special_notes: this.specialNotes,
      manifest_priority_level: this.manifest_priority_level,
      expectedDate: this.expectedDate,
      damages: this.damages,
      totalNetWeight: this.totalNetWeight,
      shipmentQuantity: this.shipmentQuantity,
      net_terms: this.net_terms,
      description_techs: this.description_techs,
      manifestStatus: this.manifestStatus,
      no_manifest_priority_level: this.no_manifest_priority_level,
      isPaid: this.isPaid,
      clientName: this.clientName,
      pictureRequired: this.pictureRequired,
      save_as_a_template: this.saveAsTemplate,
      name_template: this.templateName,
      proNumber: this.proNumber,
      equipmentComingToWarehouse: this.equipmentComingToWarehouse,
      esgReportingRequired: this.esgReportingRequired,
      sortEquipment: this.sortEquipment,
      securitySealPictureRequired: this.securitySealPictureRequired,
      notesForReceiving: this.notesForReceiving,
      notesForManifest: this.notesForManifest,
      testingReportRequired: this.testingReportRequired,
      notesForWiping: this.notesForWiping,
      notesForSales: this.notesForSales,
      status: this.status,
      dateFirstReceived: this.dateFirstReceived,
      batchCompleted: this.batchCompleted,
      batchTotal: this.batchTotal,
      hasTheEquipmentBeenSold: this.hasTheEquipmentBeenSold,
      typeReport: this.po.typeReport,
      reference: this.reference,
      manifestCompletedDate : this.manifestCompletedDate,
      testingCompletedDate: this.testingCompletedDate,
    };

    return data;
  }
}
